import {
	DeskPageHeaderComponents,
	DeskPageHeaderRightMenuComponents,
	DeskPageHeaderMenusComponents,
	DeskPageHeaderMenuComponents,
	WidgetProps
} from '@my-types';
import { React, Styled } from '@common/3rd';
import { Envs, PATH, Storage, Utils, Ajax } from '@common';
import { Widget, PageHeader } from '@component';
import Alert from '@alert';
import { StyledComponents } from '@styles';
import {
	SYSTEM_ADMIN,
	TENANT_ADMIN,
	NORMAL,
	ALL_MENUS
} from './page-menus-consts';
import CCIB_LOGO_W from '@images/CCIB_LOGO_W.png';
type MENU = {
	path?: string | null;
	label: string;
	children?: MENU[];
	allChildren?: MENU[];
	for?: string | string[];
	always?: boolean;
	code?: string;
};

/**
 * 菜单构造器
 */
class MenuBuilder {
	menus: string[];

	constructor() {
		const account = Envs.findAccount();
		let menus = account.menus || '';
		this.menus = menus.split(',');
	}
	private isMenuAuthorized(code: string = ''): boolean {
		return this.menus.indexOf(code) !== -1;
	}
	build(): MENU[] {
		return ALL_MENUS.filter(menu => {
			return this.filterMenuByRole(menu);
		});
	}
	/**
	 * 根据角色过滤
	 */
	filterMenuByRole(menu: MENU): boolean {
		// if (Envs.isVirtualTenant() || !Ajax.isAuthorized()) {
		// 	// 没有登录, 没有任何权限
		// 	// 虚拟用户的账户, 没有任何权限
		// 	return false;
		// }
		menu.allChildren = menu.allChildren || menu.children;
		if (menu.allChildren) {
			menu.children = menu.allChildren.filter(child => {
				return this.filterMenuByRole(child);
			});
			if (menu.children.length === 0 && !menu.path) {
				// 本身不是叶子菜单, 也没有子菜单
				return false;
			}
		}

		if (!menu.for) {
			// 没有定义角色, 都可以用
			return true;
		}
		const roles = Utils.toArray(menu.for);
		if (Envs.isSystemOwnerAdmin()) {
			// 系统管理员只要菜单定义中包含角色即可访问
			return roles.includes(SYSTEM_ADMIN);
		} else if (Envs.isTenantAdmin()) {
			// 租户管理员需要菜单定义中包含角色
			// 并且菜单为始终可访问, 或者该菜单被授权
			return (
				roles.includes(TENANT_ADMIN) &&
				(menu.always === true || this.isMenuAuthorized(menu.code))
			);
		} else {
			// 一般需要菜单定义中包含角色
			// 并且菜单为始终可访问, 或者该菜单被授权
			return (
				roles.includes(NORMAL) ||
				(menu.always === true ) // || this.isMenuAuthorized(menu.code)
			);
		}
	}
}

type PROPS = {
	menu: MENU;
} & WidgetProps;
/**
 * 菜单
 */
class Menu extends Widget<PROPS, any, DeskPageHeaderMenuComponents> {
	protected initComponents(): DeskPageHeaderMenuComponents {
		return {
			Box: Styled.div.attrs({
				'data-widget': 'desk-page-menu'
			})`
				/* min-width: 800vw; */
				position: relative;
				// margin-top: 6px;
				// padding-right: ${props => props.theme.BTN_HORIZONTAL_PADDING}px;
				color: ${props => props.theme.COLOR_REVERSED};
				cursor: pointer;
				user-select: none;

				&:hover {
					background: ${props => props.theme.COLOR_PRIMARY_LIGHT};
					> div {
						display: flex;
					}
				}
				padding: 10px 25px;
			`,
			SubMenus: Styled.div.attrs({
				'data-widget': 'desk-page-sub-menus'
			})`
				min-width: 200px;
				box-shadow: 0 3px 4px rgba(0, 0, 0, 0.258824);
				display: none;
				flex-direction: column;
				cursor: pointer;
				position: absolute;
				left: -10px;
				z-index: 1;
				// margin-top: 15px;
				top: 60px;
				border-radius: ${props => props.theme.BORDER_RADIUS}px;
				overflow: hidden;
			`,
			SubMenu: Styled.div.attrs({
				'data-widget': 'desk-page-sub-menu'
			})`
				display: flex;
				padding: ${props => props.theme.BTN_HORIZONTAL_PADDING}px;
				color: #333;
				background-color: rgba(256, 256, 256, .9);// ${props => props.theme.COLOR_PRIMARY};
				&:hover {
					color: #fff;
					background-color: ${props => props.theme.COLOR_PRIMARY};
					opacity: .7;
					> div {
						display: flex;
					}
				}
				> span {
					flex-grow: 1;
				}
				> i {
					line-height: ${props => props.theme.BTN_HEIGHT}px;
					margin-right: ${props => 0 - props.theme.BTN_HORIZONTAL_PADDING / 2}px
				}
			`,
			SubMenus2: Styled.div.attrs({
				'data-widget': 'desk-page-sub-menu2'
			})`
				min-width: 200px;
				box-shadow: 3px 0 4px rgba(0, 0, 0, 0.258824), -3px 0 4px rgba(0, 0, 0, 0.258824), 0 3px 4px rgba(0, 0, 0, 0.258824);
				display: none;
				flex-direction: column;
				position: absolute;
				left: calc(100% - 5px);
				z-index: 100;
			`,
			SubMenu2: Styled.div.attrs({
				'data-widget': 'desk-page-sub-menu2'
			})`
				padding: 0 ${props => props.theme.BTN_HORIZONTAL_PADDING}px;
				background-color: ${props => props.theme.COLOR_PRIMARY};
				&:hover {
					background-color: ${props => props.theme.COLOR_PRIMARY_LIGHT};
				}
			`
		};
	}
	private renderSecondarySubMenus(
		parentMenu: MENU,
		parentMenuIndex: number
	): JSX.Element[] | void {
		if (!parentMenu.children) {
			return;
		}

		const C = this.getComponents();
		return [
			<StyledComponents.FAS
				icon="chevron-right"
				key={`dir-${parentMenuIndex}`}
			/>,
			<C.SubMenus2 key="sub">
				{parentMenu.children
					.filter(subMenu => {
						return subMenu != null;
					})
					.map((subMenu, subMenuIndex) => {
						return (
							<C.SubMenu2
								key={`secondary-sub-menu-${parentMenuIndex}-${subMenuIndex}`}
								onClick={this.onSecondaryMenuClicked.bind(
									this,
									subMenu
								)}
							>
								<span>{subMenu.label}</span>
							</C.SubMenu2>
						);
					})}
			</C.SubMenus2>
		];
	}
	private renderSubMenus(parentMenu: MENU): JSX.Element | void {
		if (!parentMenu.children) {
			return;
		}

		const C = this.getComponents();
		return (
			<C.SubMenus>
				{parentMenu.children
					.filter(subMenu => {
						return subMenu != null;
					})
					.map((subMenu, subMenuIndex, all) => {
						// z-index倒排, 以便让下一级菜单正确显示. 原因不明, 此为workaround
						return (
							<C.SubMenu
								onClick={this.onSubMenuClicked.bind(
									this,
									subMenu
								)}
								key={`sub-menu-${subMenuIndex}`}
								style={{ zIndex: all.length - subMenuIndex }}
							>
								<span>{subMenu.label}</span>
								{this.renderSecondarySubMenus(
									subMenu,
									subMenuIndex
								)}
							</C.SubMenu>
						);
					})}
			</C.SubMenus>
		);
	}
	render() {
		const menu = this.getMenu();
		const C = this.getComponents();
		return (
			<C.Box onClick={this.onMenuClicked}>
				<span>{menu.label}</span>
				{this.renderSubMenus(menu)}
			</C.Box>
		);
	}
	private getMenu(): MENU {
		return this.props.menu;
	}
	private onMenuClicked = () => {
		this.switchPath(this.getMenu());
	};
	private onSubMenuClicked(menu: MENU): void {
		this.switchPath(menu);
	}
	private onSecondaryMenuClicked(menu: MENU): void {
		this.switchPath(menu);
	}
	private switchPath(menu: MENU): void {
		if (menu.path === '/desk/risk-warning/main') {
			window.location.href = `${window.location.protocol}//${Envs.getEnvValue(`EBAO_DOMAIN`)}${window.location.port ? `:${window.location.port}` : ''}${process.env.REACT_APP_AJAX_CLIENT_CONTEXT}${menu.path}`
		} else if (menu.path) {
			this.getHelpers()
				.getRouter()
				.pushRedirect(menu.path);
		} else if (!menu.children) {
			this.getHelpers()
				.getRouter()
				.pushRedirect(PATH.DESK_NOT_FOUND);
		}
	}
}

class Menus extends Widget<any, any, DeskPageHeaderMenusComponents> {
	protected initComponents(): DeskPageHeaderMenusComponents {
		return {
			Box: Styled.div.attrs({
				'data-widget': 'desk-page-header-menus'
			})`
				flex-grow: 1;
				display: flex;
				align-content: flex-start;
				justify-content: flex-end;
				margin-right: 20px;
			`
		};
	}
	private renderMenus(): JSX.Element[] {
		const builder = new MenuBuilder();
		return builder.build().map((menu, menuIndex) => {
			return <Menu menu={menu} key={`menu-${menuIndex}`} />;
		});
	}
	render() {
		const C = this.getComponents();
		return <C.Box>{this.renderMenus()}</C.Box>;
	}
}

/**
 * 右侧菜单
 */
class RightMenus extends Widget<any, any, DeskPageHeaderRightMenuComponents> {
	protected initComponents(): DeskPageHeaderRightMenuComponents {
		return {
			Box: Styled.div`
				display: flex;
				user-select: none;
			`,
			AccountText: Styled.div`
				margin-right: 15px;
				line-height: 60px;
				display: flex;
				> span:first-child {
					margin-right: 20px;
					cursor: pointer;
				}
				> span:last-child {
					max-width: 160px;
					text-overflow: ellipsis;
					white-space: nowrap;
					overflow: hidden;
				}
			`,
			SignOut: Styled.div`
				padding: 0 20px;
				margin: 14px 0;
				line-height: 32px;
				background: #fff;
				border-radius: ${props => props.theme.BORDER_RADIUS}px;
				color: ${props => props.theme.COLOR_PRIMARY};
				cursor: pointer;
				// i {
				// 	margin-right: 3px;
				// }
			`
		};
	}
	render() {
		const C = this.getComponents();
		return (
			<C.Box>
				<C.AccountText>
					{/* {Storage.Last.session().get('vendor') ? null : <span onClick={this.viewWarning}>风险提示</span>} */}
					<span>{Envs.findAccount().nickname}</span>
				</C.AccountText>
				{Ajax.isAuthorized() ? 
				<C.SignOut onClick={this.onSignOutClicked}>
					<span>退出</span>
				</C.SignOut> :
				<C.SignOut onClick={this.onSignInClicked}>
					<span>登录</span>
				</C.SignOut>}
			</C.Box>
		);
	}
	// private viewWarning = (): void => {
	// 	this.getHelpers().getRouter().replaceRedirect(PATH.RISK_WARNING_MAIN);
	// }
    removeStorage(domain: any) {
        let url = `${window.location.protocol}//${domain}${window.location.port ? `:${window.location.port}` : ''}`
        return Utils.iframeMessage(`${url}/rmcp/iframe.html`, 'removeStorage');
    }
	private  onSignOutClicked = (): void => {
		Alert.ask('请确认是否退出当前登录帐号').then(async () => {
			Storage.clear();
			await this.removeStorage(Envs.getEnvValue(`EBAO_DOMAIN`));
			await this.removeStorage(Envs.getEnvValue(`PICC_GI_DOMAIN`));
            await this.removeStorage(Envs.getEnvValue(`CPIC_GI_DOMAIN`));
            await this.removeStorage(Envs.getEnvValue(`PINGAN_GI_DOMAIN`));
			this.getHelpers().getRouter().replaceRedirect(PATH.DESK_SIGN);
		}, () => {});
	};
	private onSignInClicked = (): void => {
		this.getHelpers().getRouter().replaceRedirect(PATH.DESK_SIGN);
	}
}

/**
 * 桌面页眉
 */
class DeskPageHeader<
	P,
	S,
	C extends DeskPageHeaderComponents
> extends PageHeader<P, S, C> {
	protected initComponents(): C {
		return Object.assign(super.initComponents(), {
			Box: Styled.div.attrs({
				'data-widget': 'desk-page-header'
			})`
				display: flex;
				justify-content: space-between;
				position: fixed;
				top: 90px;
				width: 100vw;
				background: rgb(44 69 125 / 90%); //${props => props.theme.COLOR_PRIMARY};
				padding: 0 ${props => props.theme.DESK_HTML_HORIZONTAL_MARGIN}px;
				margin-bottom: 10px;
				color: ${props => props.theme.COLOR_REVERSED};
				height: 60px; // ${props => props.theme.DESK_PAGE_HEADER_HEIGHT}px;
				z-index: ${props => props.theme.PAGE_HEADER_Z_INDEX};
				&.no-menus {
					display: none;
				}
				${(props: any) => {
					if(Storage.Share.getThirdDeskHome()){
						return `opacity: 0;
								display:none;`
					}else{
						return ``;
					}
				}}
			`,
			HeaderTop: Styled.div.attrs({
				'data-widget': 'desk-page-header-top'
			})`
				position: fixed;
				z-index: ${props => props.theme.PAGE_HEADER_Z_INDEX - 1};
				top: 0;
				height: 150px;
				width: 100vw;
				background: linear-gradient(45deg, rgba(35,98,211,1) 0%, rgba(76,106,163,1) 100%);
				padding: 16px 40px 16px ${props => props.theme.DESK_HTML_HORIZONTAL_MARGIN}px;
				display: flex;
				color: #fff;
				& > div {
					width: 50vw;
				}
				& > img {
					margin: 0 auto; 
					display:block; 
					height: 70px;
				}
				& h3 {
					font-size: ${props => props.theme.FONT_SIZE_L2}px;
					letter-spacing: 8px;
				}
				&.no-menus {
					height: 110px;
				}
			`,
			LogoText: Styled.div.attrs({
				'data-widget': 'desk-page-header-logo-text'
			})`
				line-height: 60px;
				margin-left: 8px;
				margin-right: 50px;
				font-size: 1.1em;
				user-select: none;
			`
		});
	}
	/**
	 * 只有登录用户才需要描画菜单
	 */
	private renderAllMenus(): JSX.Element | void {
		return (
			<React.Fragment>
				{Ajax.isAuthorized() ? <Menus /> : null}
				<RightMenus />
			</React.Fragment>
		)
	}
	render() {
		const C = this.getComponents();
		return (
			<>
			<C.HeaderTop className={window.location.pathname.includes('risk-warning') ? 'no-menus' : ''}>
				<div>
					<h3>广东对外贸易与投资企业风险管控平台</h3>
					<p>Risk Management Platform for Foreign Trade and Investment Enterprises of Guangdong Province</p>
				</div>
				<img src={CCIB_LOGO_W}/>
			</C.HeaderTop>
			<C.Box className={window.location.pathname.includes('risk-warning') ? 'no-menus' : ''}>
				<C.LogoText>保险服务平台</C.LogoText>
				{this.renderAllMenus()}
			</C.Box>
			</>
		);
	}
}

export default DeskPageHeader;
